/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TMessagesOfferModel,
  IMessagesOfferRequest,
  IMappers,
  IMessagesOfferResponse,
  IMessagesOfferResponseError,
  TMessagesOfferResponse,
} from './types';

const defaultConfig: TMessagesOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/messages/offer/',
  hostType: 'api',
} as TMessagesOfferModel;

function createMessagesOfferModel(parameters: IMessagesOfferRequest): TMessagesOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IMessagesOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IMessagesOfferRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchMessagesOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IMessagesOfferOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TMessagesOfferResponse> {
  const { response, statusCode } = await httpApi.fetch(createMessagesOfferModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesOfferResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IMessagesOfferResponseError);
    }
  }

  return { response, statusCode } as TMessagesOfferResponse;
}

export { defaultConfig, createMessagesOfferModel, fetchMessagesOffer };
